// src/config.js
// export const BASE_URL = 'http://127.0.0.1:8000';

//Produção
// https://backoffice.social360.typingsolutions.pt/
export const BASE_URL = 'https://backoffice.social360.typingsolutions.pt';

//Base Vue
// export const BASE_URL_VUE = 'http://localhost:8080/#/login';

//Produção
export const BASE_URL_VUE = 'https://social360.typingsolutions.pt/#/login';